// TR-SSSV : in BE use Scsssv
export class Scsssv {
    id: string;
    wellStringId: string;
    mdSssvTypeId: string;
    oem: string;
    model: string;
    sizeIn: number;
    ratingPsi: number;
    manufacturer: string;
    partNo: string;
    installedDate: string;
    equipmentBrand: string;
    hydraulicReturn: number;
    isLockedOpen: string;
    slamTest: string;
    clPressure: number;
    blowingGas: string;
    isSelfEqualize: string;
    cycling: number;
    status: string;
    remark: string;

    constructor(initialValues: Partial<Scsssv> = {}) {
        Object.assign(this, initialValues);
    }

    reset() {
        const initialValues: Partial<Scsssv> = {
            id: '',
            wellStringId: '',
            mdSssvTypeId: '',
            oem: '',
            model: '',
            sizeIn: 0,
            ratingPsi: 0,
            manufacturer: '',
            partNo: '',
            installedDate: '',
            equipmentBrand: '',
            hydraulicReturn: 0,
            isLockedOpen: '',
            slamTest: '',
            clPressure: 0,
            blowingGas: '',
            isSelfEqualize: '',
            cycling: 0,
            status: '',
            remark: '',
        };
        Object.assign(this, initialValues);
    }
}